import { combineReducers } from "redux";
import contactData from "./contactData";

export default combineReducers({
  contactData: contactData,
});
